/**
 * Allows global usage of the MicroModal Library
 */
if (MicroModal) {
    MicroModal.init();
}

/**
 * Allows global usage of the Tooltips using the tippy.js library loaded in vendors.js
 * Tooltip JSON data is being stored in the Global Shop Metafield within the Custom Fields app in Shopify
 * A variable on the window object is being assigned to the JSON data in theme.liquid
 */
if (globalTooltipData) {
    globalTooltipData.tooltips.forEach(function (toolTip) {
        tippy(toolTip.selector, {
            content: toolTip.content,
            allowHTML: true,
            trigger: 'mouseenter click',
            onCreate(instance) {
                instance.reference.addEventListener('click', function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                })
            },
        });
    });
}


/**
 * Adds tooltips to the screen finder PLP pages built in PageFly
 * productFinderData JSON data is being assigned in product-finder.liquid from a global metafield 
 */
if (document.querySelector('.product-finder')) {
    productFinderData.rows.forEach(function (row) {
        row.cells.forEach(function (cell) {
            var tooltipElement = document.getElementById('tooltip-' + cell.number);

            if (tooltipElement) {
                var rowHeadingText = tooltipElement.closest('tr').querySelector('th').textContent;
                var columnIndex = tooltipElement.getAttribute('data-column-index');
                var columnHeadingText = document.querySelector('.js-column-headings [data-column-index="' + columnIndex + '"]').textContent;
    
                tippy('#tooltip-' + cell.number, {
                  content: '<div>The visible glass of this window measures:<br>' + columnHeadingText + ' wide by ' + rowHeadingText + ' high</div>',
                    allowHTML: true,
                    placement: 'auto'
                });
            }
        });
    });
}

/**
 * Add active class to mega menu for subcategory pages that are outside of the Shopify three level linked list limit
 */
if (document.getElementById('PartCategoriesSidebar')) {
    var activeClass = 'nav-bar__item--active';
    var topLevelMegaMenuItems = document.querySelectorAll('.nav-bar .nav-bar__item');
    var topLevelSidebarCategories = document.querySelectorAll('.part-categories-1-accordion__title');

    topLevelSidebarCategories.forEach(function(category) {
        var categoryIsActive = category.querySelector('.js-accordion__header').getAttribute('aria-expanded');
        var categoryURL = category.getAttribute('data-url');

        if (categoryIsActive === 'true') {
            for (var item of topLevelMegaMenuItems) {
                var itemURL = item.querySelector('.nav-bar__link').href;
                
                if (itemURL.includes(categoryURL)) {
                    item.classList.add(activeClass);
                }
            }
        }
    });
}

// Accessbility Fixes
window.addEventListener('load', function(event) {    
    // removes duplicate svg IDs from the DOM to ensure every id attribute value used in ARIA and in labels is unique
    var footerPaymentList = document.querySelector('.footer .payment-list');

    if (footerPaymentList) {
        var paymentIcons = footerPaymentList.querySelectorAll('.payment-list__item');

        paymentIcons.forEach(function(icon) {
            var label = icon.getAttribute('aria-labelledby') + '-footer';
            icon.querySelector('title').id = label;
            icon.setAttribute('aria-labelledby', label);
        });
    }

    // fix to add tab functionality to SearchSprings autocomplete results
    const searchInput = document.querySelector('.search-bar__input');
	searchInput.addEventListener('keydown', handleSearchInputFocus);
});

function handleSearchInputFocus(e) {
	if (e.keyCode !== 9) {
		return;
	}

	const searchInputResults = document.querySelector('.search-bar__results');
	const searchInputInner = document.querySelector('.search-bar__inner-animation');

	if (searchInputResults.getAttribute('aria-hidden') === 'false') {
		const firstFocusableElement = searchInputResults.querySelector('a');

		if (firstFocusableElement) {
            
            setTimeout(function() { 
                searchInputInner.classList.remove('ng-hide');
                searchInputResults.setAttribute('aria-hidden', 'false');
                firstFocusableElement.focus();
            }, 0);
		}
	}
}


function elementReady(selector) {
    return new Promise((resolve, reject) => {
        let el = document.querySelector(selector);
        if (el) {resolve(el);}
        new MutationObserver((mutationRecords, observer) => {
        Array.from(document.querySelectorAll(selector)).forEach((element) => {
            resolve(element);
            observer.disconnect();
        });
        })
        .observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    });
}

// truncate uncomplicated categories breadcrumbs
elementReady('#uncomplicated-breadcrumbs').then((item) => {
    const delimiter = ' - ';
    let crumbs = item.querySelectorAll('a');

    crumbs.forEach(crumb => {
        if (crumb.textContent.includes(delimiter)) {
            crumb.textContent = crumb.textContent.split(delimiter)[0];
        }
    });

    document.getElementById('uncomplicated-breadcrumbs').classList.remove('visually-hidden');
});


/**
 * Quantity Selectors on PDP
 */

if (document.querySelector('[data-section-id="product-template"]')) {
	const quantityInputElement = document.querySelector('[name="quantity"]');
	const increaseQuantityElement = document.querySelector('[data-action="increase-picker-quantity"]');
	const decreaseQuantityElement = document.querySelector('[data-action="decrease-picker-quantity"]');

	increaseQuantityElement.addEventListener('click', onIncreaseQuantity);
	decreaseQuantityElement.addEventListener('click', onDecreaseQuantity);
	quantityInputElement.addEventListener('keyup', onInputValueChanged);

	function onIncreaseQuantity(e) {
		quantityInputElement.value = parseInt(quantityInputElement.value) + 1;
	}

	function onDecreaseQuantity(e) {
		quantityInputElement.value = Math.max(1, parseInt(quantityInputElement.value) - 1);
	}

	// make sure the input value is a number
	function onInputValueChanged(e) {
		var value = e.target.value;

		if (value !== '' && isNaN(value)) {
			e.target.value = Math.max(1, parseInt(value) || 1);
		}
	}
}